import React from 'react'
import { Login } from 'react-admin'

export default (props) => <Login backgroundImage={null} {...props} />